"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNavigation = void 0;
const core_1 = require("@bluebase/core");
const BasePlugin_1 = require("./BasePlugin");
const components_1 = require("./components");
const index_1 = require("./lib/index");
var components_2 = require("./components");
Object.defineProperty(exports, "createNavigation", { enumerable: true, get: function () { return components_2.createNavigation; } });
exports.default = core_1.createPlugin(Object.assign(Object.assign({}, BasePlugin_1.BasePlugin), { components: Object.assign(Object.assign({}, BasePlugin_1.BasePlugin.components), { Navigation: {
            applyStyles: false,
            value: components_1.createNavigation(index_1.Router),
        } }) }));
